import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=a308d0fa&scoped=true"
import script from "./expert.vue?vue&type=script&lang=js"
export * from "./expert.vue?vue&type=script&lang=js"
import style0 from "./expert.vue?vue&type=style&index=0&id=a308d0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308d0fa",
  null
  
)

export default component.exports